import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';

type UserRole = {
  role: string;
};

export const getLineUserRole = async (lineAccessToken: string): Promise<ApiResult<UserRole>> => {
  const { status, result } = await callApiWithoutToken<UserRole>(
    `line/user/role`,
    'GET',
    lineAccessToken
  );
  return { status, result };
};
